(() => {
  if (window.ssPdpVariantGuardReady) return;
  window.ssPdpVariantGuardReady = true;
  const pending = new Map();
  const setBusy = (id, busy) => {
    const form = document.getElementById(id);
    const info = form?.closest('.product-info');
    if (busy) {
      form?.setAttribute('aria-busy', 'true');
      info?.setAttribute('data-ss-variant-pending', '');
    } else {
      form?.removeAttribute('aria-busy');
      info?.removeAttribute('data-ss-variant-pending');
    }
  };
  document.addEventListener('change', event => {
    const picker = event.target.closest?.('main .product-info variant-picker');
    if (!picker || !event.target.matches('[data-option-position]')) return;
    const id = picker.getAttribute('form-id');
    if (!id) return;
    pending.set(id, true);
    setBusy(id, true);
  }, true);
  document.addEventListener('variant:change', event => {
    const id = event.target.getAttribute?.('id');
    if (!pending.has(id)) return;
    pending.delete(id);
    queueMicrotask(() => setBusy(id, false));
  });
  document.addEventListener('submit', event => {
    if (!pending.has(event.target.getAttribute?.('id'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
  document.addEventListener('click', event => {
    const button = event.target.closest?.('button[type="submit"], input[type="submit"]');
    if (!button?.form || !pending.has(button.form.getAttribute('id'))) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  }, true);
})();